import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
//   mode: "history",
    routes: [
        {
            path: "/",
            name: "index",
            redirect: "/home",
        },
        {
            path: "/home",
            name: "home",
            component: () => import("./components/view/Home")
        },
        {
            path: "/screening-post-login",
            name: "postLogin",
            component: () => import("./components/view/ScreeningBlankPage")
        },
        {
            path: "/external-login-screening",
            name: "externalLogin",
            component: () => import("./components/view/ExternalLoginPage")
        },
        {
            path: "/login",
            name: "login",
            component: () => import("./components/view/LoginPage")
        },
        {
            path: "/login-mobile",
            name: "loginMobile",
            component: () => import("./components/view/LoginPageMobile")
        },
        {
            path: "/confirm",
            name: "confirm",
            component: () => import("./components/view/Confirm")
        },
        {
            path: "/filling",
            name: "filling",
            component: () => import("./components/view/FillingPageSwitch")
        },
        {
            path: "/filling-mobile",
            name: "fillingMobile",
            component: () => import("./components/view/FillingPageMobile")
        },
        // {
        //     path: "/filling-switch",
        //     name: "fillingSwitch",
        //     component: () => import("./components/view/FillingPageSwitch")
        // },
        {
            path: "/browser-warning",
            name: "browser-warning",
            component: () => import("./components/view/IEPage"),
        },
        // {
        //     path: "/404",
        //     name: "404",
        //     component: () => import("./components/view/Page404"),
        // },
        // {
        //     path: "*",
        //     redirect: "/404",
        //     hidden: true,
        //     children: []
        // },
        {
            path: "/resetPassword",
            name: "reset password",
            component: () => import("./components/view/ResetPasswordPage"),
        },
        {
            path: "/viewing",
            name: "viewData",
            component: () => import("./components/view/DataViewingPage"),
        },
        {
            path: "/viewing-mobile",
            name: "viewDataMobile",
            component: () => import("./components/view/DataViewingPageMobile"),
        },
        {
            path: "/policy",
            name: "policy",
            component: () => import("./components/view/Policy"),
        },
        {
            path: "/referee-upload",
            name: "refereeUpload",
            component: () => import("./components/view/RefereeUpload"),
        },
        // for screening
        {
            path: "/screening",
            name: "screening",
            component: () => import("./components/view/ScreeningPage"),
        },
        {
            path: "/login-screening",
            name: "login screening",
            component: () => import("./components/view/HomeScreening")
        },
        {
          path: "/access-screening",
          name: "home screening",
          component: () => import("./components/view/LoginPageScreening")
        },
        // for additional information collection
        {
            path: "/data-collection",
            name: "data collection",
            component: () => import("./components/view/DataCollectionPage")
        },
        {
            path: "/e-check-list",
            name: "eCheckList",
            component: () => import("./basic_components/ECheckList"),
        }
    ]
});
